import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { PsrCustomerSettings } from "@/models/psr/customerSettings/psrCustomerSettings"
import { IPsrCustomerSettings } from "@/models/psr/psr.types"
import {
  IPsrCustomerVulnerabilityRaw,
  PsrCustomerVulnerabilityParser,
} from "@/models/psr/customerVulnerability/psrCustomerVulnerability.parser"
import { PsrCustomerServiceParser } from "../customerService/psrCustomerService.parser"
import { PsrCustomerSettingsResponse } from "@/api/backofficeRest/generated/model"

export type IPsrCustomerSettingsRaw = PsrCustomerSettingsResponse

export const PsrCustomerSettingsParser: IParser<
  IPsrCustomerSettings,
  IPsrCustomerSettingsRaw
> = {
  toDomain: (data: IPsrCustomerSettingsRaw) => {
    try {
      return new PsrCustomerSettings(
        data.customerServices.map((customerService) =>
          PsrCustomerServiceParser.toDomain(customerService),
        ),
        data.customerVulnerabilities.map(
          (customerVulnerability: IPsrCustomerVulnerabilityRaw) =>
            PsrCustomerVulnerabilityParser.toDomain(customerVulnerability),
        ),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
